import {Entity} from "../helpers/Entity"

export type PasswordStrengthDto = {
    Score: number,
    IsAcceptable: boolean
}

export default class PasswordStrength implements Entity{
    dto: PasswordStrengthDto

    constructor(dto: PasswordStrengthDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return !!this.dto
    }

    getId(): string {
        return ""
    }

    getScore(): number {
        return this.dto.Score
    }

    isAcceptable(): boolean {
        return this.dto.IsAcceptable
    }
}


// WEBPACK FOOTER //
// ./src/state/auth/PasswordStrength.ts